import {FormArray, FormControl, FormGroup} from '@angular/forms';
import {required} from '../../../../shared/utils';
import {Pipe, PipeTransform} from '@angular/core';
import {
    CreateFunctionRequest,
    FunctionExecuteRequest,
    FunctionMetadata,
    UpdateFunctionRequest
} from '../../../../core/services/wasabi/wasabi-functions.service';

export enum ResultTabs {
    Results = 0,
    Info = 1,
    Error = 2
}

export class WasabiForm {
    public static formTemplate(metadata: FunctionMetadata, canEdit: boolean): FormGroup {

        let formGroup: FormGroup = this.formDefaultTemplate(canEdit);

        if (metadata) {
            formGroup.patchValue(metadata);
            formGroup = this.patchParams(formGroup, metadata, false);
        }

        return formGroup;
    }

    public static formDefaultTemplate(canEdit: boolean): FormGroup {
        return new FormGroup({
            id: new FormControl({
                    value: '',
                    disabled: true
                }
            ),
            name: new FormControl({
                value: '',
                disabled: !canEdit
            }, [required('Name')]),
            description: new FormControl({
                value: '',
                disabled: !canEdit
            }, [required('Description')]),
            active: new FormControl({
                value: false,
                disabled: !canEdit
            }),
            scriptPath: new FormControl({
                value: '',
                disabled: !canEdit
            }, [required('Script Path')]),
            mc2AccountId: new FormControl({
                value: null,
                disabled: !canEdit
            }),
            params: new FormArray([]),
        });
    }

    private static patchParams(form: FormGroup, metadata: FunctionMetadata, canEdit: boolean): FormGroup {

        if (metadata.params && metadata.params.length > 0) {
            const paramsControl: FormArray = form.get('params') as FormArray;
            for (const param of metadata.params) {
                const paramForm = this.paramFormTemplate(canEdit);
                paramForm.patchValue(param);
                paramsControl.push(paramForm);
            }
        }

        return form;
    }

    public static paramFormTemplate(canEdit: boolean): FormGroup {
        return new FormGroup({
            name: new FormControl({
                    value: '',
                    disabled: !canEdit
                }, [required('Param name')]
            ),
            description: new FormControl({
                    value: '',
                    disabled: !canEdit
                }, [required('Param description')]
            )
        });
    }

    private static patchTestParams(form: FormGroup, metadata: FunctionMetadata, canEdit: boolean): FormGroup {

        if (metadata.params && metadata.params.length > 0) {
            const paramsControl: FormArray = form.get('params') as FormArray;
            for (const param of metadata.params) {
                const paramForm = this.paramTestFormTemplate(param.name, canEdit);
                paramForm.patchValue(param);
                paramsControl.push(paramForm);
            }
        }

        return form;
    }

    public static paramTestFormTemplate(key, canEdit: boolean): FormGroup {
        return new FormGroup({
            key: new FormControl({
                    value: key,
                    disabled: !canEdit
                }, [required('Param name')]
            ),
            value: new FormControl('', [required('Param description')]
            )
        });
    }

    public static createFunctionRequest(rawValue: any): CreateFunctionRequest {
        const params = rawValue.params.filter(param => !!param.name);
        return {
            name: rawValue.name,
            description: rawValue.description,
            active: rawValue.active,
            mc2AccountId: rawValue.mc2AccountId,
            scriptPath: rawValue.scriptPath,
            params
        };
    }

    public static updateFunctionRequest(rawValue: any): UpdateFunctionRequest {
        return {
            id: rawValue.id,
            name: rawValue.name,
            description: rawValue.description,
            active: rawValue.active,
            scriptPath: rawValue.scriptPath,
            mc2AccountId: rawValue.mc2AccountId
        };
    }

    public static setCanEditParams(form: FormGroup) {
        const paramsControl: FormArray = form.get('params') as FormArray;
        for (const control of paramsControl.controls) {
            control.disable();
        }
    }

    public static buildTestForm(data: FunctionMetadata, branch: string, canEdit: boolean): FormGroup {
        let formGroup: FormGroup = new FormGroup({
            branch: new FormControl({
                value: branch,
                disabled: !canEdit
            }, [required('Branch')]),
            path: new FormControl({
                value: data.scriptPath,
                disabled: !canEdit
            }, [required('Path')]),
            token: new FormControl('', [required('Token')]),
            params: new FormArray([]),
        });

        formGroup = this.patchTestParams(formGroup, data, canEdit);

        return formGroup;
    }

    public static executePayload(data: any): FunctionExecuteRequest {

        const params = {};

        for (const param of data.params) {
            params[param.key] = param.value;
        }

        return {
            branch: data.branch,
            token: data.token,
            path: data.path,
            params
        };
    }
}


@Pipe({
    name: 'canEdit',
})
export class canEditPipe implements PipeTransform {
    transform(form: FormGroup, control: string): boolean {
        return !form && form.get(control).disabled;
    }
}
